import { render, staticRenderFns } from "./addWindow.vue?vue&type=template&id=38033c25"
import script from "./addWindow.vue?vue&type=script&lang=js"
export * from "./addWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports